import { render, staticRenderFns } from "./FormularioInicial.vue?vue&type=template&id=7117c947&scoped=true"
import script from "./FormularioInicial.vue?vue&type=script&lang=js"
export * from "./FormularioInicial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7117c947",
  null
  
)

export default component.exports